import { useAppSelector } from 'redux/store';

export default function useCurrentUser() {
  return useAppSelector((state) => state.user.current);
}
